import React from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import AuthorizationMatrixForm from "../components/contracts/authorizationMatrices/authorizationMatrixForm";
import AuthorizationMatrix from "../components/contracts/authorizationMatrices/AuthorizationMatrix";

const AuthorizationMatrixFormAddOrEdit = () => (
  <Container fluid className="main-content-container px-4 pb-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle
        sm="4"
        title="Matriz de Autorización"
        subtitle="Contratos"
        className="text-sm-left"
      />
    </Row>

    <Row>
      <Col md="12">
        {/*<AuthorizationMatrixForm />*/}
        <AuthorizationMatrix />
      </Col>
    </Row>
  </Container>
);

export default AuthorizationMatrixFormAddOrEdit;
